import React, { Component } from "react";
import { Button, ButtonGroup, IconButton, Input, Text } from "@chakra-ui/react";

import { AiOutlineMore } from "react-icons/ai";
import { TiDeleteOutline } from "react-icons/ti";

import { createCard, deleteCard } from "../Api/apis";

class list extends Component {
  state = {
    cardData: [],
    cardName: "",
    isaddCardclicked: false,
  };

  displayCards = async () => {
    let cards = await this.props.displayCard(this.props.data.id);
    this.setState({ cardData: cards });
  };

  onclickAddcardButton = () => {
    this.setState({ isaddCardclicked: true });
  };

  addCard = (listId, CardName) => {
    const cardData = createCard(listId, CardName);
    cardData.then((data) => {
      const list = data;
      this.setState({ cardData: [...this.state.cardData, list] });
    });
    this.setState({ isaddCardclicked: false });
  };

  removeCard = (cardId) => {
    deleteCard(cardId);
    const updatedCardData = this.state.cardData.filter(
      (item) => item.id !== cardId
    );
    this.setState({ cardData: updatedCardData });
  };

  componentDidMount() {
    this.displayCards();
  }

  renderInputField() {
    return (
      <div
        style={{
          display: "flex",
          padding: "10px",
          alignItems: "space-between",
        }}
      >
        <Input
          placeholder=""
          size="md"
          onChange={(event) => this.setState({ cardName: event.target.value })}
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            height: "50px",
          }}
        />
        <Button
          size="md"
          colorScheme="blue"
          onClick={() => this.addCard(this.props.data.id, this.state.cardName)}
          style={{ marginLeft: "10px" }}
        >
          Save
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div id="list">
          <div
            style={{
              height: "45px",
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Text fontSize="16px" color="#364547" fontWeight="bold">
              {this.props.data.name}
            </Text>
            <Button
              size="small"
              onClick={() => this.props.deleteList(this.props.data.id)}
            >
              {" "}
              <AiOutlineMore color="inherit" />
            </Button>
          </div>

          <div style={{ padding: "20px" }}>
            <ul>
              {this.state.cardData.map((item) => {
                return (
                  <div
                    style={{
                      padding: "5px",
                      backgroundColor: "#548CA8",
                      margin: "10px",
                      borderRadius: "4px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {" "}
                    <div style={{ padding: "10px", color: "white" }}>
                      {item.name}{" "}
                    </div>
                    <div style={{ padding: "10px", color: "white" }}>
                      <button
                        size="lg"
                        onClick={() => this.removeCard(item.id)}
                      >
                        <TiDeleteOutline />
                      </button>
                    </div>
                  </div>
                );
              })}
            </ul>
          </div>

          <div>{this.state.isaddCardclicked && this.renderInputField()}</div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {" "}
            <ButtonGroup size="sm" isAttached color="primary">
              <Button
                mr="-px"
                onClick={this.onclickAddcardButton}
                style={{ color: "#364547" }}
              >
                + add a card
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default list;
